import React, { useEffect, useState, useContext, useRef, useCallback } from 'react';
import { purchaseService } from '../../services/purchase.service';
import iconImage from '../../assets/Icon.svg';
import CurrencyFormat from 'react-currency-format';

import LogicContext from '../../Context/LogicContext';
import { imageService } from '../../services/image.service';

import { GetRecoilBillListData, SetRecoilBillListData, ResetRecoilBillEdit, GetRecoilBillEdit } from '../../store/billsAtom';

import { useForm } from 'react-hook-form';
import moment from 'moment';

import { useNavigate } from 'react-router-dom';
import GeneralModal from '../../helpers/GeneralModal';
import { createModal } from 'react-modal-promise';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';

import { useSearchParams } from 'react-router-dom';
import BillWareHouseName from './BillWareHouseName';
import BillPaymentTerm from './BillPaymentTerm';
import BillRate from './BillRate';
import BillTransDiscountType from './BillTransDiscountType';
import AddBillTable from './AddBillTable';
import BillVendorComponent from './BillVendornameComponent';
import BillDiscountComponent from './BillDiscountComponent';

function AddBillPage() {
  const getBillListData = GetRecoilBillListData();
  const setBillListData = SetRecoilBillListData();
  const editableBill = GetRecoilBillEdit();
  const resetEdit = ResetRecoilBillEdit();

  const navigate = useNavigate();
  const myPromiseModal = createModal(GeneralModal);
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();

  const logicContext = useContext(LogicContext);

  const [purchaseList, setPurchaseList] = useState([]);
  const [imageUrlList, setImageUrlList] = useState([]);
  const [discountValue, setDiscountValue] = useState(0);
  const [adjustmentValue, setAdjustmentValue] = useState(0);
  const [disCountTypeID, setDiscountTypeID] = useState(1);

  const mountRef = useRef(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const customVendorId = searchParams.get('vendor_id');
  const customVendorName = searchParams.get('vendor_name');

  useEffect(() => {
    if (getBillListData['Customer'] === undefined) {
      purchaseService.getBillEntryData().then(response => {
        setBillListData(response.data);
      });
    }
  }, [getBillListData, setBillListData]);

  useEffect(() => {
    if (customVendorId !== null) {
      setValue('Vendor_Id', customVendorId);
    }
  }, [customVendorId, setValue]);

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      document.title = 'Add New | Bill';

      // Set default dates for new bill
      const defaultBillDate = moment().format('YYYY-MM-DD');
      const defaultDueDate = moment().format('YYYY-MM-DD');
      setValue('Bill_Date', defaultBillDate);
      setValue('Due_Date', defaultDueDate);

      if (editableBill?.Bill_Ref_No) {
        document.title = 'Modify Bill record';
        setValue('Bill_Ref_No', editableBill?.Bill_Ref_No);
        setValue('Bill_Notes', editableBill?.Customer_Notes);
        setValue('Vendor_Id', editableBill?.Vendor_Id);
        setValue('Payment_Term_Id', editableBill?.Payment_Term_Id);
        setValue('Item_Rates_Type_Id', editableBill?.Item_Rates_Type_Id);
        setValue('discount_value', editableBill?.Discount_Value);
        setValue('adjustment_amount', editableBill?.Adjustment_Amount);
        setValue('Warehouse_Id', editableBill?.Warehouse_Id);
        setValue('Order_Number', editableBill?.Order_Number);
       
        // Fix date fields - assuming correct field names from editableBill; adjust if needed (e.g., Bill_Date_String, Due_Date_String)
        const billDate = editableBill?.Bill_Date_String
          ? moment(editableBill.Bill_Date_String, 'DD-MM-YYYY').format('YYYY-MM-DD')
          : defaultBillDate;
        const dueDate = editableBill?.Due_Date_String
          ? moment(editableBill.Due_Date_String, 'DD-MM-YYYY').format('YYYY-MM-DD')
          : defaultDueDate;
        setValue('Bill_Date', billDate);
        setValue('Due_Date', dueDate);

        setDiscountValue(editableBill?.Discount_Value);
        setAdjustmentValue(editableBill?.Adjustment_Amount);
        if (editableBill?.Attachments?.length > 0) {
          reMapImageUri(editableBill?.Attachments);
        }
      }
    }

    return () => {
      isMounted = false;
      mountRef.current = false;
      resetEdit();
    };
  }, [editableBill, setValue]);

  // ADD REMOTE IMAGE LINK TO CURRENT
  const reMapImageUri = ImageList => {
    let newList = ImageList.map(file => ({
      ...file,
      preview: imageService.BILL_IMAGE_URL + file?.Bill_Ref_No + file?.Image_Reference_No + '.' + file?.Image_Format,
    }));
    setImageUrlList(newList);
  };

  const onVendorSelect = vendor => {
    setValue('Vendor_Id', vendor.Vendor_Id);
  };

  function onPaymentTermsSelect(val) {
    setValue('Payment_Term_Id', val.Payment_Term_ID);
  }

  function onItemRateSelect(val) {
    setValue('Item_Rates_Type_Id', val.Item_Rates_Type_Id);
  }

  function onWareHouseNameSelect(val) {
    setValue('Warehouse_Id', val.Warehouse_Id);
  }

  const onSubmit = async option => {
    const purchaseForm = getValues();

    // Check if vendor is selected
    if (!purchaseForm?.Vendor_Id) {
      return logicContext.showToast('Please select a Vendor', 'info');
    }

    // Check if at least one item is selected
    if (purchaseList.length === 0) {
      return logicContext.showToast('At least one or more items must be selected!', 'info');
    }

    var tempStringList = purchaseList?.map(item => {
      let temp = ` <a> <item_id>${item.Item_Id}  </item_id>
          <item_quantity>${item?.Item_Quantity} </item_quantity>
          <item_rate>${item?.Item_Rate} </item_rate>
          <tax_id>${item?.Tax_Id ? item?.Tax_Id : 0} </tax_id>
          <account_id>${item?.Account_Id ? item?.Account_Id : 0} </account_id>
          <customer_id>${item?.Customer_Id} </customer_id>
            </a>`;
      return temp;
    });

    await myPromiseModal({
      title: 'Confirmation',
      body: editableBill?.Bill_Ref_No ? 'Record will be updated!' : 'Do you want to save this record?',
      showInput: false,
      placeHolder: '',
    })
      .then(res => {
        if (res.decision === true) {
          let option = 2;
          const newData = getValues();
          if (editableBill?.Bill_Ref_No) {
            option = 3;
          }
          // attachedFile
          const formData = new FormData();
          for (const keyData in newData) {
            formData.set(keyData, newData[keyData] ? newData[keyData] : 0);
          }
          formData.set('option', option);
          formData.set('xml_string_item', `<root> ${tempStringList.join('')} </root>`);
          formData.set('discount_value', discountValue);
          formData.set('adjustment_amount', adjustmentValue);

          if (imageUrlList?.length) {
            var tempImageStringList = '';
            let fileCount = imageUrlList?.length;

            for (let i = 0; i < imageUrlList?.length; i++) {
              let element = imageUrlList[i];
              let newFile = element.file;

              if (newFile?.name !== undefined) {
                formData.append('files', newFile);
                var fileExtension = newFile.name.split('.').pop();
                tempImageStringList += `<a> <img_refno>${'_' + i} </img_refno> <img_format>${fileExtension} </img_format> </a>`;
              } else {
                tempImageStringList += `<a> <img_refno>${element?.Image_Reference_No}</img_refno> <img_format>${element?.Image_Format} </img_format> </a>`;
              }
              fileCount = fileCount + 1;
            }

            formData.set('xml_string_img', `<root> ${tempImageStringList} </root>`);
            formData.set('Attached_File_Id', 1);
          }

          purchaseService.saveNewBill(formData).then(res => {
            if (res?.data !== undefined) {
              const { message_text, message_id } = res.data[0];
              if (message_id === 1) {
                logicContext.showToast(message_text, 'success');
                navigate(-1);
              } else {
                return logicContext.showToast(message_text, 'error');
              }
            }
          });
        }
      })
      .catch(err => {
        // logicContext.showToast('Error submitting record', 'error');
      })
      .catch(err => {
        // logicContext.showToast('Error submitting form, please try again', 'error');
      });
  };

  function onErrors(error) {
    console.error('Errorrrrr ', error);
    logicContext.showToast('Form error', 'error');
  }

  const selectFile = () => {
    document.getElementById('attached-file').click();
  };

  function attachmentHandler(e) {
    setImageUrlList([]);
    Array.from(e.target.files).map((file, i) => {
      var fileExt = file.name.split('.').pop();
      const reader = new FileReader();

      reader.addEventListener('load', () => {
        setImageUrlList(prev => [
          ...prev,
          {
            Image_Format: fileExt,
            Image_Reference_No: i,
            preview: reader.result,
            file: file,
          },
        ]);
      });
      reader.readAsDataURL(file);
    });
  }

  const removeImage = index => {
    let tempList = [...imageUrlList];
    tempList.splice(Number(index), 1);
    setImageUrlList(tempList);
  };

  const onSelectionList = tableList => {
    setPurchaseList(tableList);
  };

  const calculateSubTotal = list => {
    let result = 0;
    list?.forEach(element => {
      result += element.Item_Quantity * element.Item_Rate;
    });
    return result;
  };

  const calculateGrandTotal = list => {
    let result = 0;
    list?.forEach(element => {
      result += Number(element.Item_Quantity) * Number(element.Item_Rate);
    });

    result = result - discountValue || 0;
    result = Number(result) + Number(adjustmentValue);
    return result;
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit, onErrors)}>
        <section className="container mx-auto px-4 py-8">
          <Grid container spacing={3}>
            {/* Row 1: Vendor Name (full width for layout) */}
            <Grid item xs={12}>
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Vendor Name <span className="text-red-500">*</span>
                </label>
                <div className="flex items-center space-x-2">
                  <button className="flex items-center justify-center p-2 border border-gray-300 rounded-lg hover:bg-gray-50">
                    <svg className="w-6 h-6 text-gray-500" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M16.4996 10.875C16.4996 11.9875 16.1697 13.0751 15.5516 14.0001C14.9335 14.9251 14.055 15.6461 13.0272 16.0718C11.9994 16.4976 10.8684 16.609 9.77723 16.3919C8.68608 16.1749 7.6838 15.6391 6.89713 14.8525C6.11046 14.0658 5.57473 13.0635 5.35769 11.9724C5.14065 10.8812 5.25204 9.75024 5.67779 8.72241C6.10353 7.69457 6.8245 6.81607 7.74953 6.19798C8.67455 5.5799 9.76209 5.25 10.8746 5.25C12.3659 5.25169 13.7957 5.84487 14.8502 6.89939C15.9047 7.95392 16.4979 9.38368 16.4996 10.875ZM21.5294 21.5304C21.3888 21.6711 21.198 21.7501 20.9991 21.7501C20.8001 21.7501 20.6094 21.6711 20.4687 21.5304L16.4165 17.4783C14.7122 18.9092 12.5213 19.6269 10.3006 19.4817C8.08 19.3366 6.00111 18.3398 4.49749 16.6993C2.99387 15.0587 2.18161 12.9011 2.23008 10.6762C2.27855 8.45139 3.18402 6.33114 4.75766 4.75763C6.3313 3.18413 8.45163 2.27884 10.6765 2.23057C12.9013 2.18229 15.0589 2.99474 16.6993 4.4985C18.3398 6.00226 19.3363 8.08123 19.4813 10.3019C19.6262 12.5225 18.9083 14.7134 17.4773 16.4176L21.5294 20.4698C21.6701 20.6104 21.7491 20.8012 21.7491 21.0001C21.7491 21.199 21.6701 21.3898 21.5294 21.5304ZM10.8746 18C12.2838 18 13.6613 17.5821 14.833 16.7992C16.0047 16.0163 16.918 14.9035 17.4573 13.6016C17.9965 12.2997 18.1376 10.8671 17.8627 9.48498C17.5878 8.10287 16.9092 6.83331 15.9127 5.83686C14.9163 4.84042 13.6467 4.16182 12.2646 3.8869C10.8825 3.61199 9.44991 3.75308 8.14799 4.29236C6.84607 4.83163 5.73329 5.74486 4.95039 6.91656C4.16748 8.08826 3.74961 9.46581 3.74961 10.875C3.75175 12.764 4.5031 14.575 5.83883 15.9108C7.17457 17.2465 8.9856 17.9979 10.8746 18Z"
                        fill="#45444B"
                      />
                    </svg>
                  </button>
                  <div className="flex-1">
                    <BillVendorComponent
                      defaultVal={{ label: editableBill?.Vendor_Name || customVendorName }}
                      onVendorSelect={onVendorSelect}
                    />
                  </div>
                </div>
              </div>
            </Grid>

            {/* Row 2: Bill Number & Warehouse */}
            <Grid item xs={6}>
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-1">Bill Number</label>
                <input
                  type="text"
                  value={editableBill?.Bill_Number || ''}
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Auto generated"
                  readOnly={true}
                />
              </div>
            </Grid>
            <Grid item xs={6}>
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Warehouse Name <span className="text-red-500">*</span>
                </label>
                <BillWareHouseName defaultVal={{ label: editableBill?.Warehouse_Name }} onWareHouseNameSelect={onWareHouseNameSelect} />
              </div>
            </Grid>

            {/* Row 3: Order Number & Due Date */}
            <Grid item xs={6}>
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-1">Order Number</label>
                <input
                  type="number"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder=""
                  {...register('Order_Number')}
                />
              </div>
            </Grid>
            <Grid item xs={6}>
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Due Date <span className="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  {...register('Due_Date', { required: 'Due date is required' })}
                />
                {errors.Due_Date && <p className="text-red-500 text-xs mt-1">{errors.Due_Date.message}</p>}
              </div>
            </Grid>

            {/* Row 4: Bill Date & Payment Terms */}
            <Grid item xs={6}>
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Bill Date <span className="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  {...register('Bill_Date', { required: 'Bill date is required' })}
                />
                {errors.Bill_Date && <p className="text-red-500 text-xs mt-1">{errors.Bill_Date.message}</p>}
              </div>
            </Grid>
            <Grid item xs={6}>
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-1">Payment Terms</label>
                <BillPaymentTerm defaultVal={{ label: editableBill?.Payment_Term_Name }} onPaymentTermsSelect={onPaymentTermsSelect} />
              </div>
            </Grid>

            {/* Row 5: Item Rate */}
            <Grid item xs={6}>
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Item Rate <span className="text-red-500">*</span>
                </label>
                <BillRate defaultVal={{ label: editableBill?.Item_Rates_Type_Name }} onItemRateSelect={onItemRateSelect} />
              </div>
            </Grid>

            {/* Table */}
            <Grid item xs={12}>
              <div className="mb-6">
                <AddBillTable defaultList={editableBill?.Bill_details} onSelectionList={onSelectionList} />
              </div>
            </Grid>

            {/* Totals Section */}
            <Grid item xs={12}>
              <div className="bg-gray-50 rounded-lg p-4 mb-6">
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <span className="text-lg font-bold text-gray-700">Sub Total</span>
                  </Grid>
                  <Grid item xs={4}></Grid>
                  <Grid item xs={4} className="text-right">
                    <CurrencyFormat
                      value={parseFloat(calculateSubTotal(purchaseList))?.toFixed(2)}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'₦'}
                      className="text-xl font-bold text-gray-900"
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <span className="text-sm font-semibold text-gray-700">Discount</span>
                  </Grid>
                  <Grid item xs={4} className="text-center">
                    <input
                      className="w-full px-3 py-2 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      type="number"
                      placeholder="0"
                      onChange={e => setDiscountValue(Number(e.target.value))}
                      value={discountValue}
                    />
                  </Grid>
                  <Grid item xs={4} className="text-right">
                    <CurrencyFormat
                      value={discountValue?.toFixed(2)}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'₦'}
                      className={`text-xl font-bold ${discountValue < 0 ? 'text-red-500' : 'text-green-500'}`}
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <span className="text-sm font-semibold text-gray-700">Adjustment</span>
                  </Grid>
                  <Grid item xs={4} className="text-center">
                    <input
                      className="w-full px-3 py-2 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      type="number"
                      step="any"
                      onChange={e => setAdjustmentValue(Number(e.target.value))}
                      value={adjustmentValue}
                    />
                  </Grid>
                  <Grid item xs={4} className="text-right">
                    <CurrencyFormat
                      value={parseFloat(adjustmentValue)?.toFixed(2)}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'₦'}
                      className={`text-xl font-bold ${adjustmentValue < 0 ? 'text-red-500' : 'text-green-500'}`}
                    />
                  </Grid>

                  <Grid item xs={8}></Grid>
                  <Grid item xs={4} className="text-right">
                    <span className="text-2xl font-bold text-gray-900 bg-blue-100 px-4 py-2 rounded-md">
                      Total (₦)
                      <CurrencyFormat
                        value={parseFloat(calculateGrandTotal(purchaseList))?.toFixed(2)}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={' '}
                        className="ml-2"
                      />
                    </span>
                  </Grid>
                </Grid>
              </div>
            </Grid>

            {/* Notes Section */}
            <Grid item xs={12}>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <div className="mb-4">
                    <label className="block text-sm font-semibold text-gray-700 mb-1">Customer Notes</label>
                    <textarea
                      {...register('Bill_Notes')}
                      className="w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 h-32 resize-none"
                      placeholder="Enter notes..."
                    />
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div className="mb-4">
                    <label className="block text-sm font-semibold text-gray-700 mb-1">Terms and Conditions</label>
                    <textarea
                      readOnly={true}
                      className="w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-md focus:outline-none h-32 resize-none"
                      placeholder="Enter the terms and conditions of your business to be displayed in your transaction"
                    />
                  </div>
                </Grid>
              </Grid>
            </Grid>

            {/* Attachments */}
            <Grid item xs={12}>
              <div className="mb-6">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Attach File(s)</label>
                <div className="relative mb-4">
                  <input
                    id="attached-file"
                    className="hidden"
                    accept=".xlsx,.xls,image/*,.doc,.docx,.ppt,.pptx,.txt,.pdf"
                    onChange={attachmentHandler}
                    multiple
                    type="file"
                  />
                  <button
                    onClick={selectFile}
                    className="w-full flex justify-between items-center px-4 py-3 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
                  >
                    <span>Click here to add attachments</span>
                    <img className="w-5 h-5" src={iconImage} alt="Attach" />
                  </button>
                </div>
                <p className="text-xs text-gray-500 mb-4">Maximum file size 5MB</p>

                <div className="grid grid-cols-3 gap-4">
                  {imageUrlList.map((file, i) => (
                    <div key={i} className="relative bg-gray-100 rounded-md overflow-hidden">
                      <img className="w-full h-32 object-cover" src={file.preview} alt={file.Image_Format} />
                      <button
                        onClick={() => removeImage(i)}
                        className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-600"
                      >
                        X
                      </button>
                    </div>
                  ))}
                </div>
                <p className="text-sm text-gray-600 mt-2">{imageUrlList?.length} file(s) selected</p>
              </div>
            </Grid>

            {/* Actions */}
            <Grid item xs={12}>
              <div className="flex justify-between items-center mt-8">
                <button
                  type="button"
                  onClick={() => navigate(-1)}
                  className="px-6 py-2 bg-white border-2 border-red-500 text-red-500 rounded-md hover:bg-red-50 transition-colors"
                >
                  CANCEL
                </button>
                <div className="flex space-x-4">
                  <button
                    type="button"
                    className="px-6 py-2 border-2 border-blue-500 text-blue-500 rounded-md hover:bg-blue-50 transition-colors"
                  >
                    SAVE AS DRAFT
                  </button>
                  <button type="submit" className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors">
                    {editableBill?.Bill_Ref_No ? 'UPDATE' : 'SAVE'}
                  </button>
                </div>
              </div>
            </Grid>
          </Grid>
        </section>
      </form>
    </>
  );
}

export default AddBillPage;
